import React, { useEffect, useState } from "react";
import get from "lodash/get";

import StoryCard7 from "../../molecules/story-card7";
import CollectionTitleHeader from "../../molecules/collection-title-header";
import Separator from "../../atoms/separator";

import { AdContainer } from "../../ads";
import { filterStory } from "../../helper/api";

import "./six-text-story-cards.m.css";

const SixTextStoryCards = ({ collection, index }) => {
  if (!(collection && collection.items)) {
    return null;
  }
  const stories = filterStory(collection);

  if (!stories.length) {
    return null;
  }

  const AdCard = ({ id, mobile }) => {
    const [isMobile, setMobile] = useState(false);

    useEffect(() => {
      if (window && window.innerWidth < 767) {
        setMobile(true);
      } else {
        setMobile(false);
      }
    }, []);
    if (index !== 1) return null;
    return (
      <>
        {isMobile ? (
          <div styleName="ad-wrapper" className="hide-desktop">
            <AdContainer AdClassName="standard-336x280" id={id} mobile={mobile} />
          </div>
        ) : null}
      </>
    );
  };

  const mobileAdUnitId1 = get(collection, ["associated-metadata", "mobileAdUnitId1"], null);
  const mobileAdUnitId2 = get(collection, ["associated-metadata", "mobileAdUnitId2"], null);
  const mobileAdUnitId3 = get(collection, ["associated-metadata", "mobileAdUnitId3"], null);

  return (
    <>
      <CollectionTitleHeader collection={collection} index={index} />
      <div styleName="border-wrapper">
        <div styleName="wrapper">
          <div styleName="stories-wrapper">
            {stories?.splice(0, 6).map((item, index) => (
              <div styleName="stories" key={index}>
                {index === 1 && <div styleName="white-box left"></div>}
                {index === 1 && <div styleName="white-box right"></div>}
                <div styleName="story-count">{index + 1}</div>
                <StoryCard7 story={item} lineClamp={2} />
                {index === 2 ? <AdCard id="div-gpt-ad-1680156938221-0" mobile={mobileAdUnitId1} /> : null}
                {index === 6 ? <AdCard id="div-gpt-ad-1680156970809-0" mobile={mobileAdUnitId2} /> : null}
              </div>
            ))}
          </div>
        </div>
        <Separator />
      </div>
    </>
  );
};

export default SixTextStoryCards;
